<div class="scrollable">
  <div class="album">
    <div class="border"></div>
    <div class="card">
      <img *ngIf="front" class="cover fade-in" src="assets/album_cover.jpg" (click)="front = !front">
      <img *ngIf="!front" class="cover fade-in" src="assets/album_back.jpg" (click)="front = !front">
    </div>
    <div class="card">
      <h1>STRAIGHT OUT OF NOTHING (2021)</h1>
      <p></p>
      <p></p>
      <p (click)="navigation.spotify()" style="cursor: pointer;">JETZT HÖREN AUF SPOTIFY
        <img class="social_icon" src="assets/iconmonstr-spotify-1.svg" style="padding-left: 5px">
      </p>
      <p (click)="navigation.bandcamp()" style="cursor: pointer;">JETZT KAUFEN AUF BANDCAMP
        <img class="social_icon" src="assets/iconmonstr-disc-11.svg" style="padding-left: 5px">
      </p>
      <p></p>
      <span (click)="navigation.home()" style="cursor: pointer;">
        <mat-icon class="back-icon">arrow_back_ios</mat-icon>
        ZURÜCK
      </span>
    </div>
    <div class="border"></div>
  </div>
</div>
